import {
  getBodyForChartRequest,
  useValidActiveChartRangeType
} from "components";
import { StatisticsChart } from "modules/dashboard";
import moment from "moment";

import { useExpensesStatistics } from "../../apis";
import { InternalBankStatisticProps } from "./InternalBankStatistic.types";

const InternalBankStatistic = ({
  dateRange,
  setDateRange
}: InternalBankStatisticProps) => {
  const { activeRangeType } = useValidActiveChartRangeType();

  const {
    statistics,
    totalAmount,
    amountToday,
    percentageChangeFromPreviousDay,
    isLoading: isLoadingStatistics
  } = useExpensesStatistics({
    ...getBodyForChartRequest(dateRange, activeRangeType),
    calculateAmountTodayFrom: moment(new Date()).format("YYYY-MM-DD")
  });

  const selectedPeriodAmount = statistics.reduce(
    (sum, statistic) => sum + statistic.totalAmount,
    0
  );

  return (
    <StatisticsChart
      totalTitle="Total Expenses (FCFA)"
      titleValue={totalAmount}
      secondaryTitle="Selected Period Expenses (FCFA)"
      secondaryValue={selectedPeriodAmount}
      isLoadingSecondary={isLoadingStatistics}
      comparablePeriodTitle="Today"
      customPercentageInComparablePeriodValue={percentageChangeFromPreviousDay}
      comparablePeriodValue={amountToday}
      dateRange={dateRange}
      setDateRange={setDateRange}
      isLoading={isLoadingStatistics}
      isLoadingForCompare={isLoadingStatistics}
      chartData={statistics.map((statistic) => ({
        date: statistic.date,
        value: statistic.totalAmount
      }))}
    />
  );
};

export default InternalBankStatistic;
